import config from '@wearetla/tla-essentials-tools/config';

const registeredModals = {
	options: () => import('/views/modals/options'),
	confirm: () => import('/views/modals/confirm'),
	message: () => import('/views/modals/message'),
	agreement: () => import('/views/modals/agreement'),
	agreementUpdate: () => import('/views/modals/agreement-update'),
	auth: () => import(/* webpackPrefetch: true */ '/views/modals/auth'),
	mobileMenu: () => import(/* webpackPrefetch: true */ '/views/modals/mobile-menu'),
	otpPin: () => import('/views/modals/otp-pin'),
	walletQr: () => import(/* webpackPrefetch: true */ '/views/modals/wallet-qr'),
	paymentQrReader: () => import('/views/modals/payment-qr-reader'),
	walletQrPair: () => import('/views/modals/wallet-qr-pair'),
	...(config.wallet?.enableNfcPayment ? {
		paymentNfcReader: () => import('/views/modals/payment-nfc-reader'),
		walletNfcPair: () => import('/views/modals/wallet-nfc-pair'),
	} : {}),
	bookingQrReader: () => import('/views/modals/booking-qr-reader'),
	bookingSmsCheck: () => import('/views/modals/booking-sms-check'),
	ticketQr: () => import('/views/modals/ticket-qr'),
	notifications: () => import(/* webpackPrefetch: true */ '/views/modals/notifications'),
	walletRefund: () => import('/views/modals/wallet-refund'),
	walletRefundIbanInput: () => import('/views/modals/wallet-refund-iban-input'),
	walletHistory: () => import('/views/modals/wallet-history'),
	workshopAttendance: () => import('/views/modals/workshop-attendance'),
	languages: () => import('/views/modals/languages'),
	bankRedirect: () => import('/views/modals/bank-redirect'),
	userWalletInfo: () => import('/views/modals/user-wallet-info'),
	loadWalletBalance: () => import('/views/modals/load-wallet-balance'),
	userQrSearch: () => import('/views/modals/user-qr-search'),
};

export default registeredModals;
